import React, { useEffect, useState } from 'react';
import { Button, Nav, NavItem, NavLink } from 'reactstrap';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//API
import roteiroDeFiscalizacao_api from '../../../../../api/roteiroDeFiscalizacao_api';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { getSessionCookie } from '../../../../../helpers/cookies';

//Components
import MainCard from '../../../../../components/MainCard';
import Identificacao from './Identificacao';
import Etapas from './Etapas';
import Workflow from './Workflow';

//Context
import { useAuth } from '../../../../../context/auth';

function initialStateRoteiroFiscalizacao(secretaria_id) {
    return {
        identificacao: "",
        status: "Ativo",
        arquivo: "",
        formulario_Id: "Nenhum",
        situacaoInicial: "",
        secretaria_Id: secretaria_id,
        etapas: []
    }
}

function RoteiroFiscalizacaoStepper({ id = null, handleVoltar, editavel = false }) {
    //Dados de autenticação
    const session = getSessionCookie();

    //State para criar / editar roteiro fiscalização
    const [roteiroFiscalizacao, setRoteiroFiscalizacao] = useState(initialStateRoteiroFiscalizacao(session.secretaria_Id));

    //State de controle da exibição dos steps
    const [activeStep, setActiveStep] = useState(1);

    const { setLoading } = useAuth();

    const loadRoteiroFiscalizacao = async (id) => {
    const roteiroId = roteiroFiscalizacao?.id ?? id;

    if (!roteiroId) return;

        try {
            setLoading(true);

            const { data } = await roteiroDeFiscalizacao_api.getItem(roteiroId);

            const parseBoolean = (value) => (value ? "true" : "false");

            const etapas = data.etapas?.map((value) => ({
                ...value,
                formulario_Id: value.formulario_Id?.toString() ?? "Nenhum",
                calcularJuros: parseBoolean(value.calcularJuros),
                permiteAlterarEmail: parseBoolean(value.permiteAlterarEmail),
                reenvioEmailAutomatico: parseBoolean(value.reenvioEmailAutomatico),
                inicioPrazoProximoDiaUtil: parseBoolean(value.inicioPrazoProximoDiaUtil),
                fimPrazoProximoDiaUtil: parseBoolean(value.fimPrazoProximoDiaUtil),
            }));

            setRoteiroFiscalizacao({
                ...data,
                formulario_Id: data.formulario_Id?.toString(),
                etapas,
            });

        } catch (err) {
            showMessage("Error", err?.message ?? "Erro na operação.", "error", null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!!id)
            loadRoteiroFiscalizacao(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 1:
                return <Identificacao
                    roteiroFiscalizacao={roteiroFiscalizacao}
                    setRoteiroFiscalizacao={setRoteiroFiscalizacao}
                    loadRoteiroFiscalizacao={loadRoteiroFiscalizacao}
                    editavel={editavel}
                />
            case 2:
                return <Etapas
                    roteiroFiscalizacao={roteiroFiscalizacao}
                    loadRoteiroFiscalizacao={loadRoteiroFiscalizacao}
                    editavel={editavel}
                />
            case 3:
                return <Workflow
                    roteiroFiscalizacao={roteiroFiscalizacao}
                    loadRoteiroFiscalizacao={loadRoteiroFiscalizacao}
                    editavel={editavel}
                />
            default:
                return null;
        }
    }

    return <>
        <Button
            onClick={handleVoltar}
            className='px-4'><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
        </Button>
        <MainCard>
            <Nav tabs>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => { setActiveStep(1); }}
                    >
                        Identificação
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!roteiroFiscalizacao?.id) {
                                showMessage("Aviso", "Salve a identificação para prosseguir", "info", null);
                                return;
                            }

                            setActiveStep(2);
                        }}
                    >
                        Etapas
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 3 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 3 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!roteiroFiscalizacao?.id || roteiroFiscalizacao?.roteiroFiscalizacaoEtapa?.length == 0) {
                                showMessage("Aviso", "Salve a identificação e as etapas para prosseguir", "info", null);
                                return;
                            }

                            setActiveStep(3);
                        }}
                    >
                        Workflow
                    </NavLink>
                </NavItem>
            </Nav>
            <div className="mt-4">
                {getContent()}
            </div>
        </MainCard>
    </>;
}

export default RoteiroFiscalizacaoStepper;